import React, { useState } from "react";
import { ListGroup, Button, Form, InputGroup } from "react-bootstrap";

function ItemList({
  items,
  deleteItem,
  updateItem,
  updateCheckedItem,
  updateSelectedItem,
}) {
  const [editingId, setEditingId] = useState(null);
  const [editName, setEditName] = useState("");
  const [editPrice, setEditPrice] = useState("");
  const [editQuantity, setEditQuantity] = useState("");
  const [editDiscount, setEditDiscount] = useState("");

  const handleEdit = (item) => {
    setEditingId(item.id);
    setEditName(item.name);
    setEditPrice(item.price);
    setEditQuantity(item.quantity);
    setEditDiscount(item.discount || 0); // Initialiser la remise à 0 si elle n'existe pas 
  };

  const handleUpdate = (id) => {
    if (!editName || !editPrice || !editQuantity) return; // Vérifie que les champs ne sont pas vides avant de mettre à jour
    if (editDiscount < 0) {
      alert("La remise ne peut pas être négative. Veuillez entrer une valeur positive.");
      return; // Empêche la mise à jour si la remise est négative
    }
    updateItem(id, editName, editPrice, editQuantity, editDiscount);
    setEditingId(null);
  };

  const handleCheckedChange = (item) => {
    if (item.selected === false) return;
    const ok = window.confirm("FAIT / ANNULER FAIT ?");
    if (ok) updateCheckedItem(item.id, !item.checked); // Met à jour l'état 'checked' de l'élément
  };

  const handleSelectedChange = (item) => {
    const ok = window.confirm("CHOISIR / NE PLUS CHOISIR ?");
    if (ok) updateSelectedItem(item.id, !item.selected); // Met à jour l'état 'selected' de l'élément
  };

  return (
    <ListGroup className='mb-3'>
      {items.map((item) => (
        <ListGroup.Item className='border-dark' key={item.id}>
          {editingId === item.id ? (
            <>
              <InputGroup className='mb-2'>
                <Form.Label htmlFor='edit-item-name' visuallyHidden>
                  Nom de l'article
                </Form.Label>
                <Form.Control
                  id='edit-item-name'
                  className='border-info'
                  placeholder="Nom de l'article"
                  value={editName}
                  onChange={(e) => setEditName(e.target.value)}
                />
              </InputGroup>
              <InputGroup className='mb-2'>
                <Form.Label htmlFor='edit-item-price' visuallyHidden>
                  Prix
                </Form.Label>
                <Form.Control
                  id='edit-item-price'
                  className='border-info'
                  placeholder='Prix'
                  type='number'
                  value={editPrice}
                  onChange={(e) => setEditPrice(e.target.value)}
                />
              </InputGroup>
              <InputGroup className='mb-2'>
                <Form.Label htmlFor='edit-item-quantity' visuallyHidden>
                  Quantité
                </Form.Label>
                <Form.Control
                  id='edit-item-quantity'
                  className='border-info'
                  placeholder='Quantité'
                  type='number'
                  value={editQuantity}
                  onChange={(e) => setEditQuantity(e.target.value)}
                />
              </InputGroup>
              <InputGroup className='mb-2'>
                <Form.Label htmlFor='edit-item-discount' visuallyHidden>
                  Remise
                </Form.Label>
                <Form.Control
                  id='edit-item-discount'
                  className='border-danger'
                  placeholder='Remise (valeur positive)'
                  type='number'
                  value={editDiscount}
                  onChange={(e) => setEditDiscount(e.target.value)}
                />
              </InputGroup>
              <Button
                variant='success'
                onClick={() => handleUpdate(item.id)}
                className='btn-sm me-2'>
                Enregistrer
              </Button>
              <Button
                variant='danger'
                onClick={() => deleteItem(item.id)}
                className='btn-sm'>
                Supprimer
              </Button>
            </>
          ) : (
            <>
              <span>
                <strong>{item.name}</strong>
              </span>
              <span className='mx-2'>{item.price.toFixed(2)}€</span>
              <span className='mx-2'>{item.quantity}</span>
              <span className='mx-2' style={{ color: +item.discount !== 0 ? '#dc3545' : undefined }}>
                {(item.price * item.quantity - item.discount).toFixed(2)}€
              </span>
              <Button
                variant='warning'
                onClick={() => handleEdit(item)}
                className='btn-sm me-2'>
                Modifier
              </Button>
            </>
          )}
          {/* <Button
            variant='danger'
            onClick={() => deleteItem(item.id)}
            className='btn-sm'>
            Supprimer
          </Button> */}
          {editingId !== item.id && (
            <Form.Check
              id={`item-selected-${item.id}`}
              type='checkbox'
              label='Choisi'
              checked={item.selected} // Définit l'état de la case (coerce en boolean)
              onChange={() => handleSelectedChange(item)} // Gère le clic sur la case 'selected'
              className='d-inline-block ms-3 blue-checkbox'
            />
          )}
          {editingId !== item.id && (
            <Form.Check
              id={`item-checked-${item.id}`}
              type='checkbox'
              label='Fait'
              checked={item.checked} // Définit l'état de la case (coerce en boolean)
              onChange={() => handleCheckedChange(item)} // Gère le clic sur la case 'checked'
              className='d-inline-block ms-3 red-checkbox'
            />
          )}
        </ListGroup.Item>
      ))}
    </ListGroup>
  );
}

export default ItemList;
